import { render, staticRenderFns } from "./DialogDocumentList.vue?vue&type=template&id=22905480&scoped=true"
import script from "./DialogDocumentList.vue?vue&type=script&lang=js"
export * from "./DialogDocumentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22905480",
  null
  
)

export default component.exports